import {Component, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Refresher} from 'ionic-angular';
import {StripeServiceProvider} from "../../providers/stripe-service/stripe-service";
import {BookingServiceProvider} from "../../providers/booking-service/booking-service";
import moment from "moment";

//@todo Display the payment history data in the page
//@todo associate and display the services for the payment data
@IonicPage()
@Component({
  selector: 'page-payment-history',
  templateUrl: 'payment-history.html',
})
export class PaymentHistoryPage {

  public loading: boolean = true;
  public loadingMore: boolean = false;
  public bookings: Array<object> = [];
  public tuid: string;

  public currentPage: number;
  public nextPage: number;
  public lastPage: number;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public bookingService: BookingServiceProvider
  ) {
    this.tuid = localStorage.getItem('tuid');
  }

  ionViewDidLoad() {
    this.loading = true;
    this.getBookingPayments().then(() => {
      this.loading = false;
    })
  }

  getBookingPayments() {
    return this.bookingService.bookingsPaidForByUser(this.tuid).then((bookings: any) => {
      this.setPagination(bookings);
      this.bookings = bookings.data;
      return bookings;
    });
  }

  setPagination(bookings){
    this.lastPage = bookings.last_page;
    this.currentPage = bookings.current_page;
    this.nextPage = (this.currentPage < this.lastPage ? this.currentPage + 1 : null);
  }

  getBookingPaymentsFromPage(page: number){
    return new Promise((resolve,reject)=>{
      this.bookingService.bookingsPaidForByUser(this.tuid, page).then((bookings: any) => {
        this.setPagination(bookings);
        return resolve(bookings.data);
      }).catch((error)=>{
        return reject(error);
      });
    });
  }

  loadMore(){
    this.loadingMore = true;
    this.getBookingPaymentsFromPage(this.nextPage).then((bookings: any)=>{
      this.bookings = this.bookings.concat(bookings);
      this.loadingMore = false;
    }).catch((error)=>{
      this.loadingMore = false;
    });
  }

  getDateFromTimestamp(dateString){
    return moment(dateString, 'YYYY-MM-DD hh:mm:ss').format('Do MMM YYYY');
  }

  getTimeFromTimestamp(dateString){
    return moment(dateString, 'YYYY-MM-DD hh:mm:ss').format('hh:mma');
  }

  parseNumber(number){
    return Number(number);
  }

  pullToRefresh() {
    this.getBookingPayments().then(()=>{
        this.refresher.complete();
    }).catch(()=>{
      this.refresher.complete();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/payment-history/payment-history.ts